<template>
  <v-row class="ma-6">
    <v-col cols="12" md="6" class="order-md-1">
      <h1 class="caption text-uppercase text-center mb-2">Preview</h1>
      <FbStatusView :id="id" :status="status" class="mx-auto" />
      <v-row>
        <v-spacer></v-spacer>
        <v-btn class="primary mx-2 my-8" router to="content" append>Edit Content</v-btn>
        <v-btn class="primary mx-2 my-8" router to="comments" append>Edit Comments</v-btn>
        <v-spacer></v-spacer>
      </v-row>
    </v-col>
    <v-col cols="12" md="6" class="order-md-0">
      <h1 class="caption text-uppercase text-center">Meta</h1>
      <v-row wrap>
        <v-col cols="12" sm="12">
          <v-text-field
            v-model.trim="status._ref"
            label="Reference"
            filled
            required
            hide-details
            placeholder="snake_case_by_convention"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="12">
          <v-combobox
            v-model="status._tags"
            chips
            label="Tags"
            multiple
            hide-details
            filled
          >
            <template v-slot:selection="{ attrs, item, select, selected }">
              <v-chip
                v-bind="attrs"
                :input-value="selected"
                close
                @click:close="removeTag(item)"
              >
                <strong>{{ item }}</strong>
              </v-chip>
            </template>
          </v-combobox>
        </v-col>
      </v-row>
      <h1 class="caption text-uppercase text-center mt-4">Basic Info</h1>
      <v-row wrap>
        <v-col cols="12" sm="12" lg="6">
          <FbMemberAutocomplete
            v-model="status.author"
            label="Author" />
        </v-col>
        <v-col cols="12" sm="12" lg="6">
          <FbTextField
            v-model="status.action"
            label="Action" />
        </v-col>
        <v-col cols="12" sm="12" lg="6">
          <v-menu
            v-model="dateModal"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="date"
                label="Date"
                readonly
                filled
                hide-details=""
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="date"
              @input="dateModal = false"
            ></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="12" sm="12" lg="6">
          <v-menu
            ref="time"
            v-model="timeModal"
            :close-on-content-click="false"
            :nudge-right="40"
            :return-value.sync="time"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="time"
                label="Time"
                filled
                readonly
                hide-details
                v-on="on"
              ></v-text-field>
            </template>
            <v-time-picker
              v-if="timeModal"
              v-model="time"
              full-width
            >
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="timeModal = false">Cancel</v-btn>
              <v-btn text color="primary" @click="$refs.time.save(time)">OK</v-btn>
            </v-time-picker>
          </v-menu>
        </v-col>
        <v-col cols="12" sm="12" lg="6">
          <FbTextField
            v-model="status.meta"
            label="Trigger" />
        </v-col>
        <v-col cols="12" sm="12" lg="6">
          <v-checkbox
            v-model="status.sponsored"
            label="Sponsored"
            class="mt-4 pa-0"
            hide-details />
        </v-col>
        <v-col cols="12" sm="12">
          <FbTextField
            v-model="status.caption"
            label="Caption"
            textarea />
        </v-col>
      </v-row>
      <h1 class="caption text-uppercase text-center mt-4">Stats</h1>
      <v-row wrap>
        <v-col cols="12" sm="6">
          <v-text-field
            v-model.number="status.likeCount"
            label="Likes"
            type="number"
            filled
            hide-details
          ></v-text-field>
          <v-checkbox
            v-model="status.likeable"
            label="Likeable"
            hide-details
          ></v-checkbox>
          <v-checkbox
            v-model="status.liked"
            label="Liked"
          ></v-checkbox>
          <v-text-field
            v-model.number="status.commentCount"
            label="Comments (fake if max)"
            type="number"
            filled
            hide-details
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="6">
          <v-text-field
            v-model.number="status.shareCount"
            label="Shares"
            type="number"
            filled
            hide-details
          ></v-text-field>
          <v-checkbox
            v-model="status.shareable"
            label="Shareable"
            hide-details
          ></v-checkbox>
          <v-checkbox
            v-model="status.shared"
            label="Shared"
            hide-details
          ></v-checkbox>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import moment from 'moment'

import FbStatusView from '../components/FbStatus'
import FbMemberAutocomplete from '../components/FbMemberAutocomplete'
import FbTextField from '../components/FbTextField'
import FbMemberMixin from '../mixins/fb-member'

import { vueObjectAssign } from '../utils'

export default {
  name: 'FbStatus',
  mixins: [FbMemberMixin],
  components: {
    FbStatusView,
    FbMemberAutocomplete,
    FbTextField
  },
  created() {
    vueObjectAssign(this.status, {
      _ref: '',
      _tags: [],
      timestamp: 1388534400000,
      likeCount: 0,
      likeable: true,
      liked: false,
      shareCount: 0,
      shareable: true,
      shared: false,
      comments: {},
      commentCount: 0,
      content: {}
    })
  },
  data() {
    const { id } = this.$route.params
    return {
      id,
      status: this.Store.fb.posts[id],
      dateModal: false,
      timeModal: false
    }
  },
  computed: {
    date: {
      get() {
        return moment.utc(this.status.timestamp).format().substring(0, 10)
      },
      set(value) {
        value = moment.utc(value, 'YYYY-MM-DD')
        value = moment.utc(this.status.timestamp)
          .year(value.year())
          .month(value.month())
          .date(value.date())
        this.status.timestamp = value.valueOf()
      }
    },
    time: {
      get() {
        return moment.utc(this.status.timestamp).format('HH:mm')
      },
      set(value) {
        value = moment.utc(value, 'HH:mm')
        value = moment.utc(this.status.timestamp)
          .hour(value.hour())
          .minute(value.minute())
          .second(value.second())
        this.status.timestamp = value.valueOf()
      }
    }
  },
  methods: {
    removeTag(tag) {
      const i = this.status._tags.indexOf(tag)
      this.status._tags.splice(i, 1)
    }
  }
}
</script>
